import React, { ReactNode, useContext } from 'react';
import { PrecheckContext } from '../../contexts/PrecheckContext';
import { FormattedMessage } from 'react-intl';

const NameAndMobile = () => {
    const { precheckInfo, setPrecheckInfo,usDotFieldEnabled } = useContext(PrecheckContext);
    return (
        <>
            <div className="form-group mb-20">
                <label htmlFor="name">
                    <FormattedMessage id="driverInfoEntryInputLabelName" defaultMessage="Name" />
                </label>
                <FormattedMessage
                    id="driverInfoEntryInputPlaceholderName"
                    defaultMessage="Enter your name">
                    {(placeholder: ReactNode) => (
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            id="name"
                            placeholder={placeholder as string}
                            value={precheckInfo.submittedName}
                            onChange={(e) =>
                                setPrecheckInfo({
                                    ...precheckInfo,
                                    submittedName: e.target.value
                                })
                            }
                        />
                    )}
                </FormattedMessage>
            </div>
            <div className="form-group mb-20">
                <label htmlFor="name">
                    <FormattedMessage
                        id="driverInfoEntryInputLabelMobile"
                        defaultMessage="Mobile Number"
                    />
                </label>
                <input
                    className="form-control"
                    type="text"
                    name="mobileNumber"
                    id="mobileNumber"
                    placeholder="0123456789"
                    value={precheckInfo.submittedPhoneNumber}
                    onChange={(e) =>
                        setPrecheckInfo({
                            ...precheckInfo,
                            submittedPhoneNumber: e.target.value
                        })
                    }
                />
            </div>
            {usDotFieldEnabled?<div className="form-group mb-20">
                <label htmlFor="usDotNumber">
                    <FormattedMessage
                        id="driverInfoEntryInputLabelUsDotNumber"
                        defaultMessage="USDOT Number"
                    />
                </label>
                <input
                    type="text"
                    className="form-control"
                    name="submittedDotNumber"
                    id="submittedDotNumber"
                    placeholder="USDOT-123456"
                    value={precheckInfo.submittedDotNumber}
                    onChange={(e) =>
                        setPrecheckInfo({
                            ...precheckInfo,
                            submittedDotNumber: e.target.value
                        })
                    }
                />
            </div>:null}
        </>
    );
};

export default NameAndMobile;
